<div class="modal-header">
  <h4 class="modal-title">Select Payment Amount</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <p>
    Total amount due: <b>{{ orgConfig.getCurrencySymbol() }}{{ booking.amount_due }}</b>
  </p>

  <ng-container *ngIf="!partialSelected">
    <button class="btn btn-block btn-primary"
            [disabled]="loading"
            [class.disabled]="loading"
            (click)="handlePayFullBalance()">
      Pay Full Balance
    </button>
    <button class="btn btn-block btn-primary"
            [disabled]="loading"
            [class.disabled]="loading"
            (click)="handleSelectPartialPayment()">
      Make Partial Payment
    </button>
  </ng-container>

  <ng-container *ngIf="partialSelected">
    <div class="form-group">
      <label for="amount">Amount to pay now</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
        </div>
        <input type="number" class="form-control" id="amount"
               min="0.01" step="0.01"
               [(ngModel)]="amount">
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </ng-container>

</div>

<div class="modal-footer">
  <ng-container *ngIf="!partialSelected">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.dismiss()">
      Cancel
    </button>
  </ng-container>
  <ng-container *ngIf="partialSelected">
    <button type="button" class="btn btn-secondary"
            [disabled]="loading"
            [class.disabled]="loading"
            (click)="handleBack()">
      Back
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loading"
            (click)="onSubmit()">
      Continue to Payment
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loading">
      Loading...
    </button>
  </ng-container>
</div>
